export const DeliveryAnnotation = 'annotation-delivery';
export const ExternalDeliveryAnnotation = 'annotation-external-delivery';
export const ExternalAnnotation = 'annotation-external';
export const AnnotationNormal = 'annotation-normal';
export const AnnotationTexts = 'annotation-texts';
export const AnnotationFloorCrop = 'annotation-floor-crop';
